import { useQuery } from "@tanstack/react-query";

import artificialInstance from "api/aiInstance";

const useSession = ({ sessionId }: { sessionId: string }) => {
    const { data, isLoading, refetch } = useQuery<any>({
        queryKey: ["get-session", sessionId],
        queryFn: async () => {
            const result = await artificialInstance.get(
                `v1/sessions/${sessionId}`,
            );
            return result?.data;
        },
    });
    return {
        session: data,
        isLoading,
        refetch,
    };
};

export default useSession;
